import agent from "../../../api/agent";
export const get = (User) =>
  agent.requests.post(`/User/get`, User);
export const list = (pagerInputModel) =>
  agent.requests.post(`/User/getpagedlist`, pagerInputModel);
export const create = (User) => agent.requests.post(`/User/create`, User);
export const update = (User) => agent.requests.post(`/User/update`, User);
export const updatePhoto = (User) => agent.requests.post(`/User/updatePhoto`, User);

export const changePassword = (User) => agent.requests.post(`/User/ChangePassword`, User);

export const deleteUser = (User) => agent.requests.post(`/User/delete`, User);

